import React from "react";
import { Link } from "react-router-dom";

// Símbolo original: dos burbujas de conversación superpuestas cuyo espacio
// negativo sugiere una aguja de brújula (orientación + aprendizaje + conversación).
export function LogoMark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6 8.5C6 7.12 7.12 6 8.5 6H26c1.38 0 2.5 1.12 2.5 2.5v11c0 1.38-1.12 2.5-2.5 2.5H14l-5 4.5V22H8.5C7.12 22 6 20.88 6 19.5v-11Z"
            fill="hsl(var(--coral))" />
      <path d="M15 16.5C15 15.12 16.12 14 17.5 14H33c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2h-2v4l-4.5-4H17.5C16.12 27 15 25.88 15 24.5v-8Z"
            fill="hsl(var(--accent))" fillOpacity="0.92" />
      <path d="M20 12.5 24 20l-4 -2 -4 2 4 -7.5Z" fill="hsl(var(--warm-white))" />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
      <LogoMark size={30} />
      {!compact && (
        <span className="font-display font-extrabold text-lg tracking-tight leading-none">
          Hallo <span className="text-primary">Suiza</span>
        </span>
      )}
    </Link>
  );
}
